// Extended English stop words list (~220 words)
export const STOP_WORDS = new Set([
  "a","able","about","across","after","all","also","am","an","and","any","are","as","at",
  "be","because","been","before","being","between","both","but","by","came","can","come",
  "could","did","do","does","each","else","every","for","from","get","got","had","has",
  "have","he","her","here","him","himself","his","how","if","in","into","is","it","its",
  "just","know","like","make","many","me","might","more","most","much","must","my",
  "never","no","not","now","of","on","only","or","other","our","out","over","said","same",
  "she","should","since","so","some","still","such","take","than","that","the","their",
  "them","then","there","these","they","this","those","through","to","too","under","up",
  "use","very","want","was","way","we","well","were","what","when","where","which","while",
  "who","whom","why","will","with","would","you","your","yourself","us","its","also",
  "i","m","s","t","re","ve","d","ll","ain","aren","couldn","didn","doesn","hadn","hasn",
  "haven","isn","mightn","mustn","needn","shan","shouldn","wasn","weren","won","wouldn",
  "about","above","according","across","actually","after","again","against","ago","ahead",
  "already","although","always","among","apart","around","away","back","behind","below",
  "beside","beyond","big","bit","certain","clearly","close","currently","definitely",
  "despite","different","done","during","early","enough","especially","even","ever","exactly",
  "far","few","find","first","following","forward","found","given","go","going","however",
  "including","instead","keep","last","later","least","less","let","long","look","mainly",
  "maybe","meanwhile","merely","might","moreover","mostly","nearly","need","often","once",
  "perhaps","please","prior","probably","put","quite","rather","really","related","seem",
  "seen","set","several","simply","slightly","soon","specifically","start","sure","things",
  "though","thus","together","toward","towards","turn","two","type","used","using","various",
  "via","within","without","yet","zero","one","two","three","four","five","six","seven",
  "eight","nine","ten","new","old","good","great","high","low","next","full","open","public",
  "free","able","make","take","come","work","need","place","part","case","week","company",
  "group","time","year","day","role","team","job","work","level","area","field","way","point"
]);
